import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { useI18n } from "../lib/i18n";
import { AuthShell, Field, SubmitBtn } from "../components/AuthShell";

export default function ResetPassword() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      toast.success(data.message);
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("reset_title")}>
      {!token ? (
        <p className="font-mono text-sm text-nhorange">Nevažeći link. <Link to="/forgot-password" className="text-nhgreen">Pokušajte ponovo</Link></p>
      ) : (
        <form onSubmit={submit}>
          <Field label={t("new_password")} testid="reset-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
          <SubmitBtn loading={loading} testid="reset-submit">{t("reset_submit")}</SubmitBtn>
        </form>
      )}
    </AuthShell>
  );
}
